import { useMemo } from 'react';

import { PaymentType, useJobContext } from 'pages/Job/context';

export interface PaymentSelectHook {
  options: PaymentType[];
}

export default function usePaymentSelect(): PaymentSelectHook {
  const { job, jobCompanyInfo, allRates, isLoading } = useJobContext();

  const showFinance = useMemo(() => {
    if (isLoading) return true;
    if (!allRates || Object.keys(allRates).length === 0) return false;
    return allRates && job?.checkout_options?.includes('apply_for_finance');
  }, [isLoading, job, allRates]);

  const showOpenBanking = useMemo(() => {
    if (isLoading) return true;
    if (!jobCompanyInfo || !job) return false;
    const hide = Boolean(jobCompanyInfo.hide_openbanking);
    if (hide) return false;
    return job?.checkout_options?.includes('pay_by_bank');
  }, [isLoading, job, jobCompanyInfo]);

  const options: PaymentType[] = useMemo(() => {
    if (isLoading) return ['FINANCE', 'OPEN_BANKING'];
    return [
      ...(showFinance ? (['FINANCE'] as PaymentType[]) : ([] as PaymentType[])),
      ...(showOpenBanking
        ? (['OPEN_BANKING'] as PaymentType[])
        : ([] as PaymentType[])),
    ];
  }, [isLoading, showFinance, showOpenBanking]);

  return {
    options,
  };
}
